import { render, staticRenderFns } from "./ExportMail.vue?vue&type=template&id=18a89c5a"
import script from "./ExportMail.vue?vue&type=script&lang=js"
export * from "./ExportMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports